import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { Configuration } from '../constant/configuration';

const TIME_FORMAT = 'HH:mm';
const DATE_TIME_SEPARATOR = ' · ';
// Below this, the date is recent enough that the year is implied and would only add noise.
const YEAR_DISPLAY_THRESHOLD_DAYS = 330;

@Pipe({
    name: 'relativeDateTime',
    pure: false
})
export class RelativeDateTimeFilter implements PipeTransform {
    constructor(private configuration: Configuration, private translate: TranslateService) {}

    transform(localDateTime: string): string {
        if (!localDateTime) {
            return '';
        }

        const date = moment(localDateTime);
        const now = moment();
        const time = date.format(TIME_FORMAT);

        if (date.isSame(now, 'day')) {
            const todayLabel = this.translate.instant('folder.activity.today') as string;
            return `${todayLabel}${DATE_TIME_SEPARATOR}${time}`;
        }

        if (date.isSame(moment(now).subtract(1, 'day'), 'day')) {
            const yesterdayLabel = this.translate.instant('folder.activity.yesterday') as string;
            return `${yesterdayLabel}${DATE_TIME_SEPARATOR}${time}`;
        }

        const dateFormat = this.configuration.dateFormats[this.translate.currentLang?.toLowerCase()] as string;
        const showYear = Math.abs(now.diff(date, 'days')) > YEAR_DISPLAY_THRESHOLD_DAYS;
        const formattedDate = date.format(showYear ? dateFormat : dateFormat.replace('/YYYY', ''));
        return `${formattedDate}${DATE_TIME_SEPARATOR}${time}`;
    }
}
